<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">个人信息确认</span>
    </p>
    <div>
      <h-alert class="alert" type="warning" show-icon closable v-if="showModal">
        <h-icon class="icon" name="prompt_fill" slot="icon"></h-icon>
        请确认信息准确性，确认后无法修改</h-alert
      >
      <h-description :column="1">
        <h-description-item
          :label-width="96"
          label="姓名"
          :contextWrap="false"
          >{{ supplementInfo.emp_name }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="工作单位"
          :contextWrap="false"
          >{{ supplementInfo.subordinate_company }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="所在子公司/部门"
          :contextWrap="false"
          >{{ supplementInfo.emp_post }}</h-description-item
        >
      </h-description>
    </div>
    <div slot="footer">
      <comp-button
        v-if="joinType === 'join'"
        class="btn-icon"
        @click="confirmCheck"
        >确定并查找队伍</comp-button
      >
      <comp-button v-else class="btn-icon" @click="confirmJoinInviteTeam"
        >确定</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import { HDescription, HDescriptionItem } from '@/components/HDescription'
import Api from '@/api/competition/financialIndex'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'JoinTeamCheck',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 加入团队的类型join：主动加入队伍，invite：受邀加入队伍
    joinType: {
      type: String,
      default: 'join'
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton,
    HDescription,
    HDescriptionItem
  },
  computed: {
    ...mapState({
      supplementInfo: (state) => state.financialCompetition.supplementInfo,
      team: (state) => state.financialCompetition.beInvitedTeamInfo
    })
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    confirmCheck() {
      Api.putCompetEmp(this.supplementInfo).then((res) => {
        this.$emit('stateChange', 'joinTeamSearch')
        this.GetCompeteUser()
      })
    },
    confirmJoinInviteTeam() {
      Api.putCompetEmp(this.supplementInfo).then((res) => {
        this.procJoinInviteTeam()
      })
    },
    procJoinInviteTeam() {
      Api.addCompetTeam(this.$route.query.teamId).then(
        ({ error_code, error_info }) => {
          if (error_code === '0') {
            // 获取队伍信息
            this.GetBeInviteTeam(this.$route.query.teamId).then((res) => {
              this.$emit('stateChange', 'joinInviteTeam', 'success')
            })
            this.GetCompeteUser() // 更新参赛信息
          } else {
            if (error_info.indexOf('满员') > -1) {
              // 获取队伍信息
              this.GetBeInviteTeam(this.$route.query.teamId).then((res) => {
                this.$emit('stateChange', 'joinInviteTeam', 'fail')
              })
            } else {
              this.$hMessage.error(error_info)
            }
          }
          // 去掉地址上面的teamId
          history.replaceState(
            null,
            null,
            window.location.href
              .replace(/(\?).*(?=#)/, '')
              .replace(/(\?)teamId=([^&#]*)([&#]|$)/, '')
              .replace(/(&)teamId=([^&#]*)([&#]|$)/, '')
          )
        }
      )
    },
    ...mapActions(['GetBeInviteTeam', 'GetCompeteUser'])
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.check-warn {
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #ff3030;
  line-height: 22px;
  margin-left: 52px;
  margin-top: 24px;
}
.alert {
  border: none;
  .icon {
    color: #f2b044;
    font-size: 16px;
    position: relative;
    top: 2px;
  }
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamUp/JoinTeamCheck.vue